<template>
  <div class="home">
    <div class="bg-pulso"></div>
    <div class="home-content">
      <div class="pulse-logo"></div>
      <div class="pulse-description">
        {{t('text_homepage')}}
      </div>
      <location-search class="location-search-item" @change="goToLocation" :buttonLabel="t('empezar')"></location-search>
      <div class="more-info" @click="displayInfo(true)">
        <div class="info-button"></div>
        {{t('info_pulso')}}
      </div>
    </div>
    <div class="pulso-info-panel" v-if="showInfo">
      <div class="pulso-info-content" v-click-outside="clickOutsideCheck">
        <div class="close-panel" @click="displayInfo(false)"></div>
        <div class="pulse-logo"></div>
        <div v-html="t('info_pulso_tooltip')"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Api from '@/api'
import LocationSearch from '@/components/LocationSearch'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Home',
  data() {
    return {
      showInfo: false
    }
  },
  methods: {
    displayInfo(show) {
      this.showInfo = show
    },
    clickOutsideCheck(evt) {
      if (evt.target.className != 'more-info' && evt.target.className !='info-button'){
        this.displayInfo(false)
      }
    },
    goToLocation(location) {
      let preservedQuery = this.$route.query.current_date?{current_date:this.$route.query.current_date}:null
      location && this.$router.push({ path: `/${location.glk}/${location.id}`, query:preservedQuery})
    }
  },
  mounted () {
  },
  components: {
    LocationSearch
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="stylus">
.home
  background-image url('~@/assets/images/bg/trama.png')
  background-repeat: repeat;
  padding-top: vh(30px)
  height 100vh
  min-height 580px
  overflow hidden
  position relative
  .pulse-logo
    background-image url('~@/assets/images/pulse-logo.svg')
    background-size contain
    background-repeat: no-repeat;
    background-position: center center;
  .bg-pulso
    display flex
    width 100%
    height 100%
    top 0
    left 0
    z-index 0
    position absolute
    background-image url('~@/assets/images/manos.png')
    background-size contain
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center bottom;

  .home-content
    m-max-width-container(padding: 20px)
    align-content center
    z-index 1
    position relative
    .desktop &
      width 50%
      margin auto
    .pulse-logo
      width 50%
      height 80px
      margin: auto;
      margin-bottom vh(20px)
    .pulse-description
      font-family 'Lato'
      font-weight $fw-regular
      text-align center
      margin-bottom vh(25px)
      m-font-size(15,20)
    .location-search-item
      padding: vh(20px) vw(20px)
      .desktop &
        padding 0px
        width 75%
        margin auto
    .more-info
      display flex
      flex-direction row
      margin auto
      justify-content: center
      align-items: center
      font-family 'Lato'
      m-font-size(11,20)
      margin-top vh(16px)
      cursor pointer
    .info-button
      margin-right vw(5px)
      background-image url('~@/assets/icons/info_blue.svg')
      background-size contain
      background-repeat: no-repeat;
      background-position: center center;
      height vw(20px)
      width vw(20px)
  .pulso-info-panel
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    z-index 10
    background rgba(0,0,0,0.6)
    display flex
    align-items center
    justify-content center
    .pulso-info-content
      background #ffffff
      width vw(425px)
      min-height vh(415px)
      padding vw(25px)
      margin vw(15px)
      font-family 'Lato'
      m-font-size(12, 18)
      position relative
      .close-panel
        position absolute 
        top vw(12px)
        right vw(12px)
        width vw(18px)
        height vw(18px)
        cursor pointer
        background-image url('~@/assets/icons/close-panel.svg')
        background-size contain
        background-repeat: no-repeat;
        background-position: center center;
      .pulse-logo
        width vw(130px)
        height vh(72px)
        margin auto
        margin-bottom vh(10px)
</style>
